import { Autocomplete, TextField } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { HomeAction } from '../reducers/homeReducer';
import {
  getSearchIcon,
  getSearchType,
} from '../pages/Home/helpers/getAutoComplete';
import { SearchData } from './MultiStageSearch';

interface Props {
  title: string;
  value: string;
  action: () => void;
  isFocused: boolean;
  isLastElement?: boolean;
  content: React.ReactElement;
  dispatch?: React.Dispatch<HomeAction>;
  setShowPopover?: (showPopover: boolean) => void;
  autoCompleteValueOption?: SearchData[];
}

const MultiStageSearchButton: FC<Props> = ({
  title,
  value,
  action,
  isFocused,
  isLastElement,
  content,
  dispatch,
  autoCompleteValueOption,
}) => {
  const [autoCompleteValue, setAutoCompleteValue] = useState<string>('');
  const [autoCompleteId, setAutoCompleteValueId] = useState<number>(0);
  const [autoCompleteType, setAutoCompleteValueType] = useState<number>(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (
      autoCompleteValue !== '' &&
      autoCompleteType !== 0 &&
      autoCompleteId !== 0 &&
      dispatch
    ) {
      dispatch({ type: 'SET_DESTINATION', payload: autoCompleteValue ?? '' });
      dispatch({ type: 'SET_DESTINATION_ID', payload: autoCompleteId ?? 0 });
      dispatch({ type: 'SET_SEARCH_TYPE', payload: autoCompleteType ?? 0 });
    }
    dispatch && dispatch({ type: 'SET_CURRENT_STAGE', payload: 2 });
    setOpen(false);
  }, [dispatch, autoCompleteValue, autoCompleteId, autoCompleteType]);

  const handleInputChange = (_event: unknown, newInputValue: string) => {
    if (newInputValue.length > 0) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  return (
    <div
      className={`relative w-full ${
        isFocused ? 'rounded-[2rem] bg-white' : ''
      }`}
    >
      <div
        className={`flex flex-col w-full 
            pl-8 my-2 pr-2
            focus:py-2 focus:rounded-full cursor-pointer ${
              isLastElement ? 'pr-32 border-r-0' : 'border-r'
            }`}
        onClick={() => action()}
      >
        <div className="text-sm text-santtai-500">{title}</div>
        <div
          className={`text-base text-santtai-800 ${
            isFocused && title === 'Where' ? 'w-full' : ''
          }`}
        >
          {isFocused && autoCompleteValueOption && title === 'Where' ? (
            <div>
              <Autocomplete
                options={autoCompleteValueOption}
                open={open}
                onInputChange={(event, newInputValue) => {
                  handleInputChange(event, newInputValue);
                }}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '& .MuiAutocomplete-endAdornment': {
                    visibility: 'hidden',
                  },
                  '& .MuiInputBase-root': {
                    padding: '0 !important',
                  },
                  '& .MuiAutocomplete-clearIndicator': {
                    visibility: 'hidden',
                  },
                  '& .MuiAutocomplete-inputRoot': {
                    height: '23px !important',
                    padding: '0 !important',
                  },
                  padding: '0px',
                }}
                onChange={(
                  _event: unknown,
                  newValue: { label: string; type: number; id: number } | null,
                ) => {
                  setAutoCompleteValueId(newValue ? newValue.id : 0);
                  setAutoCompleteValue(newValue ? newValue.label : '');
                  setAutoCompleteValueType(newValue ? newValue.type : 0);
                }}
                renderOption={(props, option) => (
                  <li {...props}>
                    <div className="rounded-2xl border border-neutral-100 p-3 mr-4">
                      {getSearchIcon(option.type)}
                    </div>
                    <div>
                      <div className="text-sm">{option.label}</div>
                      <div className="text-xs text-neutral-500">
                        {getSearchType(option.type)}
                      </div>
                    </div>
                  </li>
                )}
                renderInput={params => (
                  <TextField {...params} fullWidth autoFocus={isFocused} />
                )}
              />
            </div>
          ) : (
            value
          )}
        </div>
      </div>
      {isFocused && !open && (
        <div className="absolute top-20 z-50">{content}</div>
      )}
    </div>
  );
};

export default MultiStageSearchButton;
